/*  Constantes del Proyecto */

//FMB
//import {default as configDefault} from '../empresas/fmbSolutions';

//JACUZZI
//import { default as configDefault } from '../empresas/jacuzzi';

//CIG
//import { default as configDefault } from '../empresas/cig';

//Colusa
//import { default as configDefault } from '../empresas/colusa';

//Rinitsa
import { default as configDefault } from '../empresas/rintisa';

//Costagas
//import { default as configDefault } from '../empresas/costagas';

//RedHogar
//import { default as configDefault } from '../empresas/redHogar';

//Vite
//import { default as configDefault } from '../empresas/vite';

//Ethon
//import { default as configDefault } from '../empresas/ethon';

//Duperu
//import {default as configDefault} from '../empresas/duperu';

//Moran
//import {default as configDefault} from '../empresas/moran';

//Soluex
//import {default as configDefault} from '../empresas/soluex';

//Maquitec
//import {default as configDefault} from '../empresas/maquitec';



export const config = configDefault;


/* ===================== ACTIONS REDUCERS DISPATCH ==================== */

export const VIEW_NAME = {
    DASHBOARD_VIEW: 'dashboardView',
    ITEMS_VIEW: 'itemsView',
    SHOPPING_CART_VIEW: 'shoppingCartView',
    BACK_ORDER_VIEW: 'backOrderView',
    PROFILE_VIEW: 'profileView',
    ORDERS_VIEW: 'ordersView',
    CONTACT_US_VIEW: 'contactUsView',
    ABOUT_US_VIEW: 'aboutUsView',
    SELECT_ADDRESS_VIEW: 'selectAddressView',
    VALIDATE_ORDER_VIEW: 'validateOrderView',
    CREATE_ORDER_VIEW: 'createOrderView',
    PROMO_VIEW: 'PromocionalesView',
    AUTORIZA_VIEW: 'AutorizacionesView',
    CANALMODERNO_VIEW: 'MiddlewareView'
};

export const DISPATCH_ID = {
    /* Config */
    CONFIG_SET_SPINNER: 'CONFIG_SET_SPINNER',
    CONFIG_SET_HISTORY_REFERENCE: 'CONFIG_SET_HISTORY_REFERENCE',
    CONFIG_SET_LOG_OUT_REFERENCE: 'CONFIG_SET_LOG_OUT_REFERENCE',
    CONFIG_SET_BEFORE_UNLOAD_REFERENCE: 'CONFIG_SET_BEFORE_UNLOAD_REFERENCE',
    CONFIG_CLEAN_REDUCER: 'CONFIG_CLEAN_REDUCER',

    /* Notification */
    NOTIFICATION_SET_ALERT_REFERENCE: 'NOTIFICATION_SET_ALERT_REFERENCE',

    /* login */
    LOGIN_SET_USER: 'LOGIN_SET_USER',
    LOGIN_SET_NAME: 'LOGIN_SET_NAME',
    LOGIN_SET_RFC: 'LOGIN_SET_RFC',
    LOGIN_SET_PHONE: 'LOGIN_SET_PHONE',
    LOGIN_SET_PHONE_2: 'LOGIN_SET_PHONE_2',
    LOGIN_SET_PASSWORD: 'LOGIN_SET_PASSWORD',
    LOGIN_SET_VALIDATE_PASSWORD: 'LOGIN_SET_VALIDATE_PASSWORD',
    LOGIN_SET_ADDRESS: 'LOGIN_SET_ADDRESS',
    LOGIN_SET_STREET: 'LOGIN_SET_STREET',
    LOGIN_SET_SUBURB: 'LOGIN_SET_SUBURB',
    LOGIN_SET_CITY: 'LOGIN_SET_CITY',
    LOGIN_SET_CP: 'LOGIN_SET_CP',
    LOGIN_SET_COUNTRY: 'LOGIN_SET_COUNTRY',
    LOGIN_SET_STATE: 'LOGIN_SET_STATE',
    LOGIN_CLEAN_REDUCER: 'LOGIN_CLEAN_REDUCER',

    LOGIN_SET_CFDI: 'LOGIN_SET_CFDI',

    /* Data to billing */
    LOGIN_SET_ADDRESS_BILL: 'LOGIN_SET_ADDRESS_BILL',
    LOGIN_SET_STREET_BILL: 'LOGIN_SET_STREET_BILL',
    LOGIN_SET_SUBURB_BILL: 'LOGIN_SET_SUBURB_BILL',
    LOGIN_SET_CITY_BILL: 'LOGIN_SET_CITY_BILL',
    LOGIN_SET_CP_BILL: 'LOGIN_SET_CP_BILL',
    LOGIN_SET_COUNTRY_BILL: 'LOGIN_SET_COUNTRY_BILL',
    LOGIN_SET_STATE_BILL: 'LOGIN_SET_STATE_BILL',

    /* Session */
    SESSION_SET_ROLE: 'SESSION_SET_ROLE',
    SESSION_SET_USER: 'SESSION_SET_USER',
    SESSION_SET_ADDRESSES: 'SESSION_SET_ADDRESSES',
    SESSION_SET_TOKEN: 'SESSION_SET_TOKEN',
    SESSION_SET_REMEMBER_USER: 'SESSION_SET_REMEMBER_USER',
    SESSION_SET_BUSINESS_ID: 'SESSION_SET_BUSINESS_ID',
    SESSION_CLEAN_REDUCER: 'SESSION_CLEAN_REDUCER',

    /* ItemsReducer */
    ITEMS_SET_ITEMS: 'ITEMS_SET_ITEMS',
    ITEMS_SAVE_ITEMS_FILTER: 'ITEMS_SAVE_ITEMS_FILTER',
    ITEMS_SET_ITEM_DETAILS: 'ITEMS_SET_ITEM_DETAILS',
    ITEMS_SET_SEARCH: 'ITEMS_SET_SEARCH',
    ITEMS_SET_CATEGORY: 'ITEMS_SET_CATEGORY',
    ITEMS_SAVE_TAGS: 'ITEMS_SAVE_TAGS',
    ITEMS_OPEN_ITEM_DETAILS_REFERENCE: 'ITEMS_OPEN_ITEM_DETAILS_REFERENCE',
    ITEMS_UPDATE_FAVORITE_REFERENCE: 'ITEMS_UPDATE_FAVORITE_REFERENCE',
    ITEMS_ADD_SHOPPING_CART_REFERENCE: 'ITEMS_ADD_SHOPPING_CART_REFERENCE',
    ITEMS_ADD_BACK_ORDER_REFERENCE: 'ITEMS_ADD_BACK_ORDER_REFERENCE',
    ITEMS_DELETE_BACK_ORDER_REFERENCE: 'ITEMS_DELETE_BACK_ORDER_REFERENCE',
    ITEMS_DELETE_SHOPPING_CART_REFERENCE: 'ITEMS_DELETE_SHOPPING_CART_REFERENCE',
    ITEMS_SET_SEARCH_BY_KEY_REFERENCE: 'ITEMS_SET_SEARCH_BY_KEY_REFERENCE',
    ITEMS_SET_SEARCH_BY_CATEGORIES_REFERENCE: 'ITEMS_SET_SEARCH_BY_CATEGORIES_REFERENCE',
    ITEMS_CLEAN_REDUCER: 'ITEMS_CLEAN_REDUCER',    
    ITEMS_SET_IDCATEGORY: 'ITEMS_SET_IDCATEGORY',
    
    // Paginacion 
    ITEMS_SET_TOTALROWS: 'ITEMS_SET_TOTALROWS',
    ITEMS_SET_NEXTPAGE: 'ITEMS_SET_NEXTPAGE',
    ITEMS_SET_LOCATION: 'ITEMS_SET_LOCATION',

    // Tipo de busqueda
    ITEMS_SET_TYPESEARCH: 'ITEMS_SET_TYPESEARCH',

    /* ShoppingCart */
    SHOPPING_CART_SAVE_CART: 'SHOPPING_CART_SAVE_CART',
    SHOPPING_CART_SAVE_BACK_ORDER: 'SHOPPING_CART_SAVE_BACK_ORDER',
    SHOPPING_CART_GET_SHOPPING_CART_REFERENCE: 'SHOPPING_CART_GET_SHOPPING_CART_REFERENCE',
    SHOPPING_CART_ITEMS_GIFT: 'SHOPPING_CART_ITEMS_GIFT',
};

export const SERVICE_API = {
    login: '/users/login',
    register: '/users/create',
    updateAddresses: '/users/updateAddresses',
    getProfile: '/profile/',
    getCategories: '/categories/',
    getImage: '/item/getImage',
    getFile: '/item/getFile',
    searchByKey: '/items/searchByKey',
    searchByCategory: '/items/searchByCategory',
    openItemDetails: '/item',
    updateFavorite: '/favorite/update',
    updateShoppingCart: '/shoppingCart/update',
    updateBackOrder: '/backOrder/update',
    updateShoppingCarLocal: '/shoppingCart/updatelocal',
    deleteShoppingCart: '/shoppingCart/delete',
    deleteBackOrder: '/backOrder/delete',
    getShoppingCart: '/shoppingCart',
    createDocument: '/createDocument',
    notifyOrders: '/users/UserNoite',
    getImageCategories: '/categories/getImage',

    getCountries: '/catalog/countries',
    getStates: '/catalog/states',
    getCFDI: '/catalog/cfdi',

    getProductsHome: '/getProductsHome',
    getCategoriesHome: '/getCategoriesHome',
    getBannerHome:'/getBannerHome',

    getOrders: '/orders',
    getOrdersSeller: '/ordersSeller',
    getOrder: '/order',
    getOrdersDetails: '/order',
    getFlete: '/item_flete',

    getDescuento: '/catalogs/getDescuento',

    getBillings: '/bill',
    getDataBillings: '/dataBill',
    getPDF: '/bills/getPDF/',
    getXML: '/bills/getXML/',

    getProdutcsDashBoard: '/items/dashBoard/',

    getQuotation: '/quotations',
    getDataQuotation: '/dataQuotation',
    createQuotation:'/createQuotations',

    getDelivery: '/deliverys',
    getDataDelivery: '/dataDelivery',
    createDelivery: '/createDelivery',

    getSaveds: '/saveds',
    getDataProduct: '/saved',
    getDataDocument: '/docuemntList',
    createSavedCart: '/createSavedCart',

    getPreliminarys: '/preliminarys',
    getDataPreliminarys: '/dataPreliminarys',
    createPreliminar: '/createPreliminary',

    getCollections: '/collections',

    getOverdueOne: '/overdueOne',
    getOverdueTwo: '/overdueTwo',
    getOverdueThree: '/overdueThree',
    getOverdueFour: '/overdueFour',
    getOverdueFive: '/overdueFive',

    getDataProfiled: '/dataProfiled',

    getBanners:'/admin/getbanners',

    seller: '/seller/login',
    listClient: '/seller/listClient',
    searchClient: '/seller/searchClient',
    searchItems:'/Items',
    getPromo:'/Promocionales',
    getPromocion : '/getPromocion',
    getPromocionDisparador :'/getPromocionDisparador',
    getConditions : '/getConditions',
    getBonificacion: '/catalogs/getBonificacion',
    tipoDisparadorVol : '/tipoDisparadorvol',
    tipoDisparadorMonto : '/tipoDisparadormonto',
    getPriceList : '/getPrices',
    //update Carrito guardado
    updateCart : '/updateCart',
    insertPromo : '/InsertPromo',
    updatePromo :'/UpdatePromo',
    aprobarPromo : '/AprobarPromo',
    activarPromo : '/ActivarPromo',
    //Update Partner
    updatePartner: '/updatePartner',
    //Autorizaciones
    getAutorizaciones : '/Autorizaciones',
    getAutorizacionesCanalModerno : '/AutorizacionesCanalModerno',
    getCreateCanalModerno : '/getCreateCanalModerno',
    createAutorization : '/createAutorization',
    rejectedAutorization : '/rejectedAutorization',
    getDatailsAuto: '/detailAuto',
    getDatailsAutoCanalModerno: '/detailAutoCanalModerno',
    loginousr : '/users/loginousr',
    //CANAL MODERNO
    validateMiddleware: '/validateProcess',
    middleware: '/process/',
    //canalModerno : '/canalModerno',
    //Conditions promocionales
    searchConditions : '/searchConditions',
    getPromocionales:'/Promo',
    getCartSaveds:'/CartSaved',
    getDetailsCartSaveds : '/DetailCartSaved',
    getOrderStatus:'/OrderStatus',
    getDetailsOrderStatus:'/DetailsOrderStatus',
    getPriceCanalModerno:'/getPriceCanalModerno',
    detailsprofile: '/detailsprofile',
    deleteCartSaved: '/deleteCartSaved',
    getDocumentsCM:'/getDocumentsCM',
    detailsSeller: '/detailsSeller',
    updateSeller: '/updateSeller',
    detailsAutorizator: '/detailsAutorizator',    
    updateAutorizator: '/updateAutorizator',
    getCreditNotes: '/creditNotes',
    getDataCreditNotes : '/dataCreditNotes',
    getDebitNotes: '/debitNotes',
    getDataDebitNotes : '/dataDebitNotes',
    getAutoCartSaveds : '/getAutoCartSaveds',
    createCartSaved : '/createCartSaved',
    getStatusAccount: '/statusAccount',
    getDatagetStatusAccount : '/dataStatusAccount',

    //REGISTRO DE PEDIDOS
    getRegistroPedidos: '/getRegistroPedidos',

    getUserFields: '/userFields/getUserFields',
};

export const SERVICE_RESPONSE = {
    SUCCESS: 1,
    EXPIRED_SESSION: -1,
    ERROR: 0,
};

export const ROLES = {
    PUBLIC: 'PUBLIC',
    CLIENT: 'CLIENT',
};

export const OBJ_TYPE = {
    ORDER: '17',
};

export const licence = config.licence; // Fecha de expiracion de la licencia